export const ACTIONS_FAVORITES = {
    ADD: 'add',
    DELETE: 'del',
    CLEAR: 'clear',
    SET: 'set',
    INIT: 'initialize',
}

export const ACTIONS_USER = {
    LOGIN: 'login',
    SIGNUP: 'signup',
    LOGOUT: 'logout',
}